import { GrpStandardScreen } from "../../../layout/grp-standard-screen";
import { Config } from "./config";
import { GrpSubMenusPathEnum } from "../../../shared/enums/grp-menus.enum";
import useStandardGrpFetch from "../../../shared/hooks/useStandardGrpFetch";
import { CreateInputs, FilterInputs } from "./components/inputs";
import tableColumns from "./components/table-columns";
import { createAnySearchForm } from "./validators/create-any-search-form.validator";

export default () => {
    const { content, fetch, loading } = useStandardGrpFetch({
        subMenuPath: GrpSubMenusPathEnum.ANY_SEARCH,
        config: Config,
    });

    return (
        <GrpStandardScreen
            title="Buscador de Dados de Tabelas/Camadas"
            url={Config.api.path}
            filters={{ fields: FilterInputs.map((input) => input()) }}
            register={{
                fields: CreateInputs.map((input) => input()),
                validator: (form) => createAnySearchForm(form),
            }}
            columns={tableColumns}
            dataSource={content?.data}
            pagination={content?.paginate}
            loading={loading}
            reFetch={fetch}
        />
    );
};
